<script setup lang="ts">
const locale = await getLocale("ko", "request_ko");

defineComponent({
    name: "RequestKO"
});

const emit = defineEmits(["init"])

onMounted(() => {
    emit("init")
})

</script>
<template>
    <div class="mx-auto lg:container text-sm sm:text-base leading-tight text-gray-700 py-4">
        <div class="absolute inset-0 flex items-center justify-center z-10 top-24 sm:top-0">
            <div class="modal-wrapper bg-white p-4 mx-4 text-center rounded-3xl mb-64 max-w-xl text-gray-700 shadow-xl">
                <i class="icon sadface block mx-auto"></i>
                <h1 class="text-3xl sm:text-3xl font-semibold md:w-2/3 mx-auto mt-4">{{ locale.title }}</h1>
                <p class="my-6">{{ locale.message }}</p>
            </div>
        </div>
    </div>
</template>